module.exports = __webpack_public_path__ + "img/swiper3.a8376e86.png";